export const STATUS = {
  DONE: 'DONE',
  LOADING: 'LOADING',
  PAUSED: 'PAUSED',
};
